import { render, staticRenderFns } from "./createOrder.vue?vue&type=template&id=05456f9b&scoped=true&"
import script from "./createOrder.vue?vue&type=script&lang=js&"
export * from "./createOrder.vue?vue&type=script&lang=js&"
import style0 from "./createOrder.vue?vue&type=style&index=0&id=05456f9b&prod&lang=scss&scoped=true&"
import style1 from "./createOrder.vue?vue&type=style&index=1&id=05456f9b&prod&lang=css&"
import style2 from "./createOrder.vue?vue&type=style&index=2&id=05456f9b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05456f9b",
  null
  
)

export default component.exports